import React from "react";

/**
 * Headline word with a persistent neon/pink color-glitch animation.
 * <GlitchText color="#c8ff2a">LOUD</GlitchText>
 */
const GlitchText = ({
  children,
  color = "#fff",
  className = "",
  as: Tag = "span",
  style: externalStyle,
  ...rest
}) => {
  return (
    <Tag
      className={`glitch-text ${className}`}
      style={{
        display: "inline-block",
        position: "relative",
        color,
        ...externalStyle,
      }}
      {...rest}
    >
      {children}
    </Tag>
  );
};

export default GlitchText;
